import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import {
  LoadingController,
  NavController,
  ViewController,
} from "ionic-angular";
import { ReferralsServiceProvider } from "../../../providers/patient-charts/referrals-service";
import { PalliativeService } from "./../../../providers/patient-charts/palliative-service";

/**
 * Generated class for the DisenrollPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-disenroll-popover",
  templateUrl: "disenroll-popover.html",
})
export class DisenrollPopoverPage {
  public reasons: FormGroup;

  public answers = [
    { choiceDesc: "Hospice enrollment", toggled: false, name: "answer1" },
    { choiceDesc: "Death", toggled: false, name: "answer2" },
    {
      choiceDesc: "Change in insurance eligibility",
      toggled: false,
      name: "answer3",
    },
    {
      choiceDesc:
        "Client living conditions found unsafe for staff contact without alternative available",
      toggled: false,
      name: "answer4",
    },
    {
      choiceDesc:
        "Patient moves out of palliative care provider's service area",
      toggled: false,
      name: "answer5",
    },
    {
      choiceDesc: "Patient chooses to disenroll",
      toggled: false,
      name: "answer6",
    },
  ];

  constructor(
    public navCtrl: NavController,
    private viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    private referralsService: ReferralsServiceProvider,
    private loadingCtrl: LoadingController,
    private palliativeService: PalliativeService
  ) {
    let groupOptions = {};
    this.answers.forEach((a) => {
      groupOptions[a.name] = [null];
    });

    this.reasons = this.formBuilder.group(groupOptions);
    const palliativeSub = this.palliativeService
      .getQuestions(this.referralsService.PATIENT_ID)
      .subscribe((resp) => {
        palliativeSub.unsubscribe();
      });
  }

  ionViewDidLoad() {
    this.reasons.setErrors({ invalid: true });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  save() {
    const loader = this.loadingCtrl.create({
      content: "Saving...",
    });
    loader.present();
    this.palliativeService
      .disenroll(this.referralsService.PATIENT_ID, this.getAnswers())
      .subscribe((response) => {
        loader.dismiss();
        this.viewCtrl.dismiss();
      });
  }

  getAnswers(): Array<string> {
    let answers = [];
    Object.keys(this.reasons.value).map((key) => {
      if (this.reasons.value[key] !== null) {
        answers.push(this.reasons.value[key]);
      }
    });

    return answers;
  }

  onToggle(answer) {
    if (answer.toggled) {
      this.reasons.get(answer.name).setValue(null);
    }

    answer.toggled = !answer.toggled;

    if (this.getAnswers().length) {
      this.reasons.setErrors(null);
    } else {
      this.reasons.setErrors({ invalid: true });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/disenroll-popover/disenroll-popover.ts